export default "__VITE_ASSET__439c90e0__"